import { adapter } from './components/cart-dialog/cart-dialog';
import {
    Bootstrap,
    Auth,
    IUser,
    ICart,
    EMPTY_CART,
    Cart,
    Checkout,
    Shop
} from '@sellox/sellox-sdk';



export class SelloxCore {

    Auth = Auth;
    Shop = Shop;
    Cart = Cart;
    Checkout = Checkout;

    cartDialog = adapter
    Handlers = {}


    loadFirestore() { return import('firebase/firestore') }


    constructor() {

    }
}